import { render, staticRenderFns } from "./benefitsWrapper.vue?vue&type=template&id=5376122b&scoped=true&"
import script from "./benefitsWrapper.vue?vue&type=script&lang=js&"
export * from "./benefitsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./benefitsWrapper.vue?vue&type=style&index=0&id=5376122b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5376122b",
  null
  
)

export default component.exports